/**
 * Working Hours API
 *
 * API functions for contractor working hours CRUD operations
 */

import { buildApiUrl, handleApiResponse } from '@/src/shared/api';
import { fetchWithTokenRefresh } from '@/src/shared/api/refreshToken';

export interface WorkingHoursDay {
  id?: string;
  dayOfWeek: number; // 0-6 (Monday=0, Sunday=6)
  startTime: string; // "HH:mm" format
  endTime: string; // "HH:mm" format
  isActive: boolean;
}

export interface UpdateWorkingHoursDto {
  workingHours: WorkingHoursDay[];
}

/**
 * Get my working hours
 */
export async function getMyWorkingHours(): Promise<WorkingHoursDay[]> {
  const url = buildApiUrl('/contractors/me/working-hours');

  const response = await fetchWithTokenRefresh(url, {
    method: 'GET',
    credentials: 'include',
  });

  return handleApiResponse<WorkingHoursDay[]>(response);
}

/**
 * Update my working hours
 */
export async function updateWorkingHours(dto: UpdateWorkingHoursDto): Promise<WorkingHoursDay[]> {
  const url = buildApiUrl('/contractors/me/working-hours');

  const response = await fetchWithTokenRefresh(url, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
    body: JSON.stringify(dto),
  });

  return handleApiResponse<WorkingHoursDay[]>(response);
}

/**
 * Get working hours by contractor ID (public)
 */
export async function getWorkingHoursById(contractorId: string): Promise<WorkingHoursDay[]> {
  const url = buildApiUrl(`/contractors/${contractorId}/working-hours`);

  const response = await fetch(url, {
    method: 'GET',
  });

  return handleApiResponse<WorkingHoursDay[]>(response);
}
